/**
 * Lifts Judge.me's rating and review count into the PDP reviews accordion header.
 *
 * The judgeme.widget metafield is written server-side and goes stale, so the
 * numbers are read from the widget Judge.me renders at runtime instead.
 */
class GcdbpReviewsSummary {
  #root;
  #target;
  #rail;

  constructor(root) {
    this.#root = root;
    this.#target = root.querySelector('[data-reviews-summary]');
    this.#rail = root.querySelector('[data-reviews-rail]');
  }

  start() {
    if (!this.#target && !this.#rail) {
      return;
    }

    if (this.#fill()) {
      return;
    }

    const observer = new MutationObserver(() => {
      if (this.#fill()) {
        observer.disconnect();
      }
    });

    observer.observe(this.#root, { childList: true, subtree: true, attributes: true });
    window.setTimeout(() => observer.disconnect(), 15000);
  }

  #fill() {
    const widget = this.#root.querySelector('.jdgm-rev-widg');
    const count = Number(widget?.dataset.numberOfReviews || 0);

    if (!widget || count < 1) {
      return false;
    }

    const average = Number(widget.dataset.averageRating || 0);

    const markup = `
      <span class="gcdbp-reviews__stars" aria-hidden="true">${this.#stars(average)}</span>
      <span class="gcdbp-reviews__score">${this.#score(average)}/5</span>
      <span class="gcdbp-reviews__count">(${count})</span>
    `;

    if (this.#target) {
      this.#target.innerHTML = markup;
    }

    if (this.#rail) {
      this.#rail.innerHTML = markup;
      this.#rail.setAttribute('aria-label', `${this.#score(average)} out of 5 from ${count} reviews`);
      this.#rail.hidden = false;
    }

    // Judge.me writes "5.00 out of 5" into one node, which is too long for a headline.
    const headline = widget.querySelector('.jdgm-rev-widg__summary-average');

    if (headline) {
      headline.textContent = this.#score(average);
    }

    return true;
  }

  #score(average) {
    return average % 1 === 0 ? String(average) : average.toFixed(1);
  }

  #stars(average) {
    let out = '';

    for (let i = 1; i <= 5; i += 1) {
      out += `<span class="gcdbp-reviews__star${i <= Math.round(average) ? ' is-on' : ''}">&#9733;</span>`;
    }

    return out;
  }
}

document.querySelectorAll('[data-gcdbp-reviews]').forEach((root) => {
  new GcdbpReviewsSummary(root).start();
});
